import React from "react";

import { makeStyles } from "../../shared/materials/helper";

import ChallanSearchInput from "../../shared/materials/Inputs/ChallanSearchInput";
import ChallanTab from "../../shared/materials/Tab/ChallanTab";
import CreateUser from "./CreateUser";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: theme.spacing(3),
  },
  header: {
    margin: 0,
    color: "rgba(54, 43, 115, 1)",
    fontSize: 32,
    fontWeight: 700,
  },
  search: {
    width: 220,
    margin: theme.spacing(0, 3),
  },
  createButton: {},
  actionSection: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
}));

const UserHeader = ({
  tabConfig,
  tabIndex,
  onTabChange,
  onUserCreate,
  onSearch,
  search,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h1 className={classes.header}>Users</h1>
      <div className={classes.actionSection}>
        <div className={classes.tabcomp}>
          <ChallanTab
            config={tabConfig}
            tabIndex={tabIndex}
            onTabChange={onTabChange}
          />
        </div>
        <div className={classes.search}>
          <ChallanSearchInput
            id="search_user_acs"
            label="Find A User..."
            value={search}
            onChange={onSearch}
            inputProps={{
              autoComplete: "new-user",
              form: {
                autoComplete: "off",
              },
            }}
          />
        </div>
        <div className={classes.createButton}>
          <CreateUser onUpdate={onUserCreate} />
        </div>
      </div>
    </div>
  );
};

export default UserHeader;
